export default __webpack_public_path__ + "static/media/img_demo_04_m.da5d7021.webp";